/**
 * Định dạng số dương
 */
export default {
  $n: 1,
  '$ n': 2,
  n$: 3,
  'n $': 4,
}
